/* ACTYVE product page redesign — behaviour for the ap-* sections */
(function () {
  'use strict';
  if (window.APProduct && window.APProduct.loaded) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  var toastEl, toastTimer;
  function toast(message, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ap-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!opts.error);
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    toastEl.appendChild(span);
    if (opts.link) {
      var a = document.createElement('a');
      a.href = opts.link.href;
      a.textContent = opts.link.text;
      toastEl.appendChild(a);
    }
    // force reflow so the transition runs
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, opts.duration || 3200);
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  /* Refresh the theme's own cart count + cart drawer (ACTYVE / Ella theme). Returns true if a drawer was opened. */
  function refreshThemeCart(cart, openDrawer) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    document.querySelectorAll('.cart-count-bubble [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var wrap = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (!wrap) return Promise.resolve(false);
    return fetch(ROOT + 'cart?view=ajax_side_cart', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (window.jQuery) { window.jQuery(wrap).html(html); } else { wrap.innerHTML = html; }
        if (openDrawer) document.body.classList.add('cart-sidebar-show');
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } })); } catch (e) {}
        return !!openDrawer;
      })
      .catch(function () { return false; });
  }

  function afterAdd(mode, message) {
    return getCart().then(function (cart) {
      if (mode === 'cart') { window.location.href = ROOT + 'cart'; return; }
      return refreshThemeCart(cart, mode === 'drawer').then(function (opened) {
        if (!opened) toast(message, { link: { href: ROOT + 'cart', text: 'View cart' } });
      });
    });
  }

  function addToCart(body) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Could not add to cart');
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------- main product ---------- */
  function initProduct(root) {
    if (!root || root.dataset.apReady === '1') return;
    root.dataset.apReady = '1';

    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    var afterAddMode = root.dataset.afterAdd || 'drawer';
    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-variants]') || {}).textContent || '[]'); } catch (e) {}

    var stage = root.querySelector('[data-stage]');
    var items = Array.prototype.slice.call(root.querySelectorAll('.ap-stage__item[data-media-id]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-media-thumb]'));
    var zoomBtn = root.querySelector('[data-zoom]');

    function activeIndex() {
      for (var i = 0; i < items.length; i++) if (items[i].classList.contains('is-active')) return i;
      return 0;
    }

    function showMedia(id) {
      id = String(id);
      var found = false;
      items.forEach(function (item) {
        var on = item.dataset.mediaId === id;
        if (on) found = true;
        if (!on && item.classList.contains('is-active')) {
          var v = item.querySelector('video');
          if (v) v.pause();
        }
        item.classList.toggle('is-active', on);
      });
      if (!found) return;
      thumbs.forEach(function (t) {
        var on = t.dataset.mediaThumb === id;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.parentNode && t.parentNode.scrollTo) {
          var p = t.parentNode;
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
          else if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
        }
      });
      if (zoomBtn) {
        var active = items[activeIndex()];
        zoomBtn.hidden = !(active && active.dataset.mediaType === 'image');
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mediaThumb); });
    });

    // swipe on touch devices
    if (stage && items.length > 1) {
      var startX = null, startY = null;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var i = activeIndex() + (dx < 0 ? 1 : -1);
        if (i < 0) i = items.length - 1;
        if (i >= items.length) i = 0;
        showMedia(items[i].dataset.mediaId);
      });
    }

    // zoom / lightbox
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var active = items[activeIndex()];
        if (!active || !active.dataset.zoomSrc) return;
        var box = document.createElement('div');
        box.className = 'ap-lightbox is-open';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-label', 'Zoomed product image');
        var img = document.createElement('img');
        img.src = active.dataset.zoomSrc;
        var srcImg = active.querySelector('img');
        img.alt = srcImg ? srcImg.alt : '';
        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'ap-lightbox__close';
        close.setAttribute('aria-label', 'Close');
        close.innerHTML = '<svg width="22" height="22" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>';
        box.appendChild(close);
        box.appendChild(img);
        document.body.appendChild(box);
        document.documentElement.style.overflow = 'hidden';
        function shut() {
          box.remove();
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', onKey);
          zoomBtn.focus();
        }
        function onKey(e) { if (e.key === 'Escape') shut(); }
        box.addEventListener('click', function (e) { if (e.target !== img) shut(); });
        document.addEventListener('keydown', onKey);
        close.focus();
      });
    }

    // quantity
    var qtyInput = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    function setQty(n) { if (qtyInput) qtyInput.value = Math.max(1, parseInt(n, 10) || 1); }
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setQty(qtyInput.value); });

    // variants
    var form = root.querySelector('form.ap-form');
    var variantInput = root.querySelector('[data-variant-input]');
    var addBtn = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var payment = root.querySelector('[data-payment]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var priceBadge = root.querySelector('[data-price-badge]');
    var stock = root.querySelector('[data-stock]');
    var stockText = root.querySelector('[data-stock-text]');
    var errorEl = root.querySelector('[data-form-error]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('.ap-option'));

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var sel = fs.querySelector('.ap-pill.is-selected');
        return sel ? sel.dataset.optionValue : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function markAvailability() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('.ap-pill').forEach(function (pill) {
          var test = opts.slice();
          test[idx] = pill.dataset.optionValue;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function updateVariant(v) {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      var available = !!(v && v.available);
      if (variantInput) variantInput.value = v ? v.id : '';
      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = !v ? 'Unavailable' : (available ? 'Add to cart' : 'Sold out');
      if (payment) payment.hidden = !available;
      if (v) {
        if (priceCurrent) priceCurrent.textContent = formatMoney(v.price, moneyFormat);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceCompare) {
          priceCompare.hidden = !onSale;
          priceCompare.textContent = onSale ? formatMoney(v.compare_at_price, moneyFormat) : '';
        }
        if (priceBadge) {
          priceBadge.hidden = !onSale;
          priceBadge.textContent = onSale ? 'Save ' + Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) + '%' : '';
        }
        if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
        if (window.history && window.history.replaceState && root.dataset.productUrl) {
          window.history.replaceState({}, '', root.dataset.productUrl + '?variant=' + v.id);
        }
      }
      if (stock) {
        stock.classList.toggle('is-out', !available);
        if (stockText) stockText.textContent = available ? stockText.dataset.in : (v ? stockText.dataset.out : 'Unavailable');
      }
      markAvailability();
    }

    fieldsets.forEach(function (fs) {
      fs.querySelectorAll('.ap-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          fs.querySelectorAll('.ap-pill').forEach(function (p) {
            p.classList.toggle('is-selected', p === pill);
            p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
          });
          var label = fs.querySelector('[data-option-selected]');
          if (label) label.textContent = pill.dataset.optionValue;
          updateVariant(findVariant(selectedOptions()));
        });
      });
    });
    if (fieldsets.length) markAvailability();

    // add to cart
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        addBtn.setAttribute('aria-busy', 'true');
        if (errorEl) errorEl.hidden = true;
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
        addToCart(new FormData(form))
          .then(function (item) {
            var title = (item && item.product_title) || 'Item';
            return afterAdd(afterAddMode, qty + ' × ' + title + ' added to your cart');
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
            toast(err.message, { error: true });
          })
          .then(function () {
            addBtn.classList.remove('is-loading');
            addBtn.removeAttribute('aria-busy');
          });
      }, true);
    }
  }

  /* ---------- accordion ---------- */
  function initAccordion(root) {
    if (!root || root.dataset.apReady === '1') return;
    root.dataset.apReady = '1';
    var single = root.dataset.single === 'true';
    var accs = Array.prototype.slice.call(root.querySelectorAll('.ap-acc'));
    accs.forEach(function (acc) {
      var trigger = acc.querySelector('.ap-acc__trigger');
      var panel = acc.querySelector('.ap-acc__panel');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var open = !acc.classList.contains('is-open');
        if (single) {
          accs.forEach(function (other) {
            if (other !== acc) {
              other.classList.remove('is-open');
              var t = other.querySelector('.ap-acc__trigger');
              var p = other.querySelector('.ap-acc__panel');
              if (t) t.setAttribute('aria-expanded', 'false');
              if (p) p.setAttribute('aria-hidden', 'true');
            }
          });
        }
        acc.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- related products ---------- */
  function bindCardButtons(root) {
    root.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      if (btn.dataset.apBound) return;
      btn.dataset.apBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        btn.classList.add('is-loading');
        var fd = new FormData();
        fd.append('id', btn.dataset.quickAdd);
        fd.append('quantity', '1');
        addToCart(fd)
          .then(function (item) {
            return afterAdd(root.dataset.afterAdd || 'drawer', ((item && item.product_title) || 'Item') + ' added to your cart');
          })
          .catch(function (err) { toast(err.message, { error: true }); })
          .then(function () { btn.classList.remove('is-loading'); });
      });
    });
  }

  function initRelated(root) {
    if (!root || root.dataset.apReady === '1') return;
    root.dataset.apReady = '1';
    var url = root.dataset.url;
    if (!url || root.dataset.static === 'true') { bindCardButtons(root); return; }
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var fresh = tmp.querySelector('[data-ap-related]');
        if (fresh && fresh.querySelector('.ap-card')) {
          root.innerHTML = fresh.innerHTML;
          root.hidden = false;
        }
        bindCardButtons(root);
      })
      .catch(function () { bindCardButtons(root); });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-ap-product]').forEach(initProduct);
    scope.querySelectorAll('[data-ap-accordion]').forEach(initAccordion);
    scope.querySelectorAll('[data-ap-related]').forEach(initRelated);
  }

  window.APProduct = { loaded: true, init: initAll, toast: toast, formatMoney: formatMoney };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
